import { CREATE, LOAD, REMOVE, UPDATE, IMPORT } from 'model/fspLoanAuthOption';
import {
  create,
  load,
  remove,
  update,
  importAndReset,
} from 'sdk/fspLoanAuthOption';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';

export const importLoanAuthOptions = () =>
  callAction({
    api: importAndReset,
    dataName: ORM,
    type: IMPORT,
  });

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(
    CREATE.ACTION,
    callAction({
      api: create,
      dataName: ORM,
      type: CREATE,
    })
  );

  yield takeEvery(
    REMOVE.ACTION,
    callAction({
      api: remove,
      dataName: ORM,
      type: REMOVE,
    })
  );

  yield takeEvery(
    UPDATE.ACTION,
    callAction({
      api: update,
      dataName: ORM,
      type: UPDATE,
    })
  );

  yield takeEvery(IMPORT.ACTION, importLoanAuthOptions());
}
